import React from "react";
import img1 from "../../../assets/img/aeroaegis_capabilities/aeroInfra.png";
import { MdOutlineEngineering, MdOutlineSpeed } from "react-icons/md";
import { AiOutlineCloudServer } from "react-icons/ai";
import { RiTeamLine } from "react-icons/ri";

export default function MainSection5() {
  return (
    <section className=" pt-5 ">
      {/* <div className="container flex flex-col place-items-center mx-auto lg:flex-row">
              <div className="lg:w-1/2 xl:w-3/5 ">
                <div className="flex items-center justify-center p-4 md:p-8 lg:p-12">
                  <img
                    src={infravue_img}
                    alt=""
                    className="w-52"
                  />
                </div>
              </div>
              <div className="flex flex-col px-6 py-8 space-y-6 rounded-sm sm:p-8 lg:p-12 lg:w-1/2 xl:w-2/5 bg-[#23307F] text-white ">
                <h3 className="text-2xl font-bold tracki sm:text-3xl ">
                AeroInfra Vue
                </h3>
                <div className="flex space-x-2 sm:space-x-4 pt-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="flex-shrink-0 w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    ></path>
                  </svg>
                  <div className="space-y-2">
                    <p className="text-lg font-medium leadi">
                    A zero-code platform that simplifies the complexity of infrastructure
design and deployment, making it accessible to businesses of all sizes.

                    </p>
                  </div>
                </div>
              </div>
            </div> */}
      <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
                AeroInfra Vue
              </h1>
              <p className="text-lg text-gray-600">
                A zero-code platform simplifying infrastructure design and
                deployment for all businesses.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              {/* Feature 1 */}
              <div className="space-y-3">
                <div className="flex items-center space-x-2">
                  <MdOutlineEngineering className="w-6 h-6 text-indigo-600" />
                  <h3 className="font-semibold text-gray-900">
                    Simplified Design
                  </h3>
                </div>
                <p className="text-gray-600 text-sm">
                  Create and deploy infrastructure effortlessly with our
                  intuitive tools.
                </p>
              </div>
              {/* Feature 2 */}
              <div className="space-y-3">
                <div className="flex items-center space-x-2">
                  <AiOutlineCloudServer className="w-6 h-6 text-indigo-600" />
                  <h3 className="font-semibold text-gray-900">
                    Cloud Integration
                  </h3>
                </div>
                <p className="text-gray-600 text-sm">
                  Seamlessly integrate with leading cloud platforms for scalable
                  solutions.
                </p>
              </div>
              {/* Feature 3 */}
              <div className="space-y-3">
                <div className="flex items-center space-x-2">
                  <MdOutlineSpeed className="w-6 h-6 text-indigo-600" />
                  <h3 className="font-semibold text-gray-900">
                    Optimized Performance
                  </h3>
                </div>
                <p className="text-gray-600 text-sm">
                  Experience enhanced efficiency and speed for your projects.
                </p>
              </div>
              {/* Feature 4 */}
              <div className="space-y-3">
                <div className="flex items-center space-x-2">
                  <RiTeamLine className="w-6 h-6 text-indigo-600" />
                  <h3 className="font-semibold text-gray-900">
                    Collaborative Tools
                  </h3>
                </div>
                <p className="text-gray-600 text-sm">
                  Empower your team with tools that simplify collaboration and
                  decision-making.
                </p>
              </div>
            </div>
          </div>

          <div className="relative h-[500px] rounded-3xl overflow-hidden">
            <img
              src={img1}
              alt="Workspace with laptop and plant"
              className="object-cover w-full h-full rounded-3xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
